import { gql } from '@apollo/client';

export const UPLOAD_SIGN_OFF_SHEET = gql`
    mutation UploadWorkSituationSignOffSheet($id: ID!, $file: Upload!) {
        uploadWorkSituationSignOffSheet(id: $id, file: $file) {
            id
        }
    }
`
